import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import Home from './Home';
import About from './About';
import { createTheme, CssBaseline, ThemeOptions } from '@mui/material';
import { ThemeProvider } from '@emotion/react';
import ExperiencePage from './ExperiencePage';
import ProjectsPage from './ProjectsPage';
import Skills from './Skills';
import Awards from './Awards';
import AppRouter from './AppRouter';

// https://zenoo.github.io/mui-theme-creator/

export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#3f51b5',
    },
    secondary: {
      main: '#008a3e',
    },
  },
  typography: {
    button: {
      textTransform: 'none'
    }
  }
};

const theme = createTheme(themeOptions);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />
  },
  {
    path: "/experience",
    element: <ExperiencePage />
  },
  {
    path: "/projects",
    element: <ProjectsPage />
  },
  {
    path: "/skills",
    element: <Skills />
  },
  {
    path: "/awards",
    element: <Awards />
  }
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRouter/>
      {/* <RouterProvider router={router} /> */}
    </ThemeProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
